(() => {
  const coverCache = new Map();
  const collator = new Intl.Collator('nl', { sensitivity: 'base' });
  const normalized = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const formatMoney = (cents) => new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format((Number(cents) || 0) / 100);
  const resultCartIcon = '<svg viewBox="0 0 28 24" aria-hidden="true"><path d="M1.5 6h5M4 3.5v5M9 4h2l2.1 10.2a2 2 0 0 0 2 1.6h7.1a2 2 0 0 0 1.9-1.5L26 7H12M16.5 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* Scrollt een doel netjes direct onder de vaste header en blijft dat corrigeren
     zolang de inhoud (async resultaten, covers) nog verschuift. Stopt zodra de bezoeker zelf scrollt. */
  const mbHeaderOffset = () => {
    const header = document.querySelector('.section-matchboox-header, .section-header');
    if (!header) return 0;
    const style = window.getComputedStyle(header);
    const stickyTop = style.position === 'sticky' || style.position === 'fixed' ? (parseFloat(style.top) || 0) : 0;
    return header.getBoundingClientRect().height + stickyTop;
  };
  const scrollBelowHeader = (target) => {
    if (!target) return;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile) {
      const resultFrame = target.matches?.('.mb-discovery__body.has-choice-result')
        ? target
        : target.closest?.('.mb-discovery__body.has-choice-result');
      if (resultFrame) target = resultFrame;
    }
    /* Op desktop blijft de resultaatkop bewust onder de vaste header in beeld.
       Mobiel sluit compacter aan zodat de volledige kaart beter in het scherm past. */
    const breathingRoom = window.matchMedia('(min-width: 990px)').matches ? 70 : mobile ? 7.56 : 24;
    const wanted = () => Math.max(0, Math.min(
      target.getBoundingClientRect().top + window.scrollY - mbHeaderOffset() - breathingRoom,
      document.documentElement.scrollHeight - window.innerHeight
    ));
    const token = {};
    window.__mbScrollToken = token;
    let cancelled = false;
    const cancel = () => { cancelled = true; };
    const events = ['wheel', 'touchstart', 'keydown'];
    events.forEach((type) => window.addEventListener(type, cancel, { passive: true }));
    const stop = () => events.forEach((type) => window.removeEventListener(type, cancel));
    window.scrollTo({ top: wanted(), behavior: 'smooth' });
    const started = Date.now();
    let lastY = -1;
    const check = () => {
      if (cancelled || window.__mbScrollToken !== token || !target.isConnected) return stop();
      const y = window.scrollY;
      const settled = Math.abs(y - lastY) < 1;
      lastY = y;
      if (settled && Math.abs(y - wanted()) > 3) window.scrollTo({ top: wanted(), behavior: 'smooth' });
      if (Date.now() - started < 2600) window.setTimeout(check, 140);
      else stop();
    };
    window.setTimeout(check, 140);
  };
  window.__mbScrollBelowHeader = scrollBelowHeader;
  const THEME_ICON_BY_HANDLE = {
    katten: 'paw',
    poezie: 'feather',
    sport: 'medal',
    'kort-en-goed': 'sparkle',
    biografieen: 'person',
    honden: 'paw',
    proza: 'book',
    'light-verse': 'note',
    'oud-goud': 'gem',
    'science-fiction': 'orbit',
    journalistiek: 'newspaper',
    muziek: 'note',
    kunst: 'frame',
    kinderboekjes: 'book-star',
    koken: 'cutlery',
    lachen: 'smile',
    studenten: 'cap',
    erotiek: 'heart',
    strips: 'speech',
    oorlog: 'peace',
    bouwkunst: 'building',
    oranjehuis: 'crown',
    voetbal: 'ball',
    'ten-afscheid': 'flower',
    wensboeken: 'gift',
    amsterdam: 'canal',
    rotterdam: 'bridge',
    liefde: 'hearts',
    theater: 'mask',
    'theater-en-cabaret': 'mask',
    'alle-auteurs': 'person',
    'alle-illustratoren': 'frame',
    newest: 'sparkle',
    series: 'book-star',
    loose: 'book'
  };
  const THEME_ICONS = {
    paw: '<svg viewBox="0 0 24 24"><circle cx="8" cy="7" r="2"/><circle cx="16" cy="7" r="2"/><circle cx="5" cy="12" r="2"/><circle cx="19" cy="12" r="2"/><path d="M8 18c0-3 1.8-5 4-5s4 2 4 5c0 1.5-1.2 2.5-4 2.5S8 19.5 8 18Z"/></svg>',
    feather: '<svg viewBox="0 0 24 24"><path d="M20 4c-7 0-12 4.5-12 11v4"/><path d="m8 15 8-8M5 20h8"/></svg>',
    medal: '<svg viewBox="0 0 24 24"><circle cx="12" cy="14" r="5"/><path d="m8 3 4 6 4-6M9.5 18.5 8 22m6.5-3.5L16 22"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24"><path d="M12 3c.7 5 2 6.3 7 7-5 .7-6.3 2-7 7-.7-5-2-6.3-7-7 5-.7 6.3-2 7-7Z"/><path d="M18 16c.3 2 1 2.7 3 3-2 .3-2.7 1-3 3-.3-2-1-2.7-3-3 2-.3 2.7-1 3-3Z"/></svg>',
    person: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3"/><path d="M5 21c.7-5 3-7 7-7s6.3 2 7 7"/></svg>',
    book: '<svg viewBox="0 0 24 24"><path d="M4 5.5C7 4.5 9.5 5 12 7v13c-2.5-2-5-2.5-8-1.5Z"/><path d="M20 5.5C17 4.5 14.5 5 12 7v13c2.5-2 5-2.5 8-1.5Z"/></svg>',
    note: '<svg viewBox="0 0 24 24"><path d="M9 18V6l10-2v12"/><circle cx="6.5" cy="18.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg>',
    gem: '<svg viewBox="0 0 24 24"><path d="m4 9 4-5h8l4 5-8 11Z"/><path d="M4 9h16M8 4l4 5 4-5M12 9v11"/></svg>',
    orbit: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="2"/><ellipse cx="12" cy="12" rx="9" ry="4"/><ellipse cx="12" cy="12" rx="4" ry="9" transform="rotate(45 12 12)"/></svg>',
    newspaper: '<svg viewBox="0 0 24 24"><path d="M4 5h16v14H4Z"/><path d="M7 8h5v4H7Zm8 0h2M15 11h2M7 15h10"/></svg>',
    frame: '<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="1"/><circle cx="9" cy="9" r="1.5"/><path d="m6 17 4-4 3 3 2-2 3 3"/></svg>',
    'book-star': '<svg viewBox="0 0 24 24"><path d="M4 5.5C7 4.5 9.5 5 12 7v13c-2.5-2-5-2.5-8-1.5Z"/><path d="M20 5.5C17 4.5 14.5 5 12 7v13c2.5-2 5-2.5 8-1.5Z"/><path d="m16 8 .7 1.4 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2Z"/></svg>',
    cutlery: '<svg viewBox="0 0 24 24"><path d="M7 3v7M4 3v4c0 2 1 3 3 3s3-1 3-3V3M7 10v11M16 3v18M16 3c3 2 4 5 4 8h-4"/></svg>',
    smile: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8.5 10h.01M15.5 10h.01M8 14c1 2 2.3 3 4 3s3-1 4-3"/></svg>',
    cap: '<svg viewBox="0 0 24 24"><path d="m3 9 9-5 9 5-9 5Z"/><path d="M7 12v5c3 2 7 2 10 0v-5M21 9v6"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M20 8c0 5-8 11-8 11S4 13 4 8c0-2.5 1.8-4 4-4 1.7 0 3 1 4 2.5C13 5 14.3 4 16 4c2.2 0 4 1.5 4 4Z"/></svg>',
    speech: '<svg viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4Z"/><path d="M8 9h8M8 12h5"/></svg>',
    peace: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 3v18M12 12 5.5 18M12 12l6.5 6"/></svg>',
    building: '<svg viewBox="0 0 24 24"><path d="M5 21V7l7-4 7 4v14M3 21h18"/><path d="M9 9h2m2 0h2m-6 4h2m2 0h2m-6 4h2m2 0h2"/></svg>',
    crown: '<svg viewBox="0 0 24 24"><path d="m4 7 4 4 4-7 4 7 4-4-2 11H6Z"/><path d="M6 21h12"/></svg>',
    ball: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="m12 8 3 2-1 4h-4l-1-4Zm0-5v5M3.5 9 9 10m11.5-1L15 10M6 18l4-4m8 4-4-4"/></svg>',
    flower: '<svg viewBox="0 0 24 24"><circle cx="12" cy="9" r="2"/><path d="M12 7c-2-5-5-3-4 0-4-1-5 3-1 4-2 4 2 5 4 2 3 3 6 0 4-2 4-5 0-4 1-4-3-5-4-2Z"/><path d="M12 13v8M12 18c-3-2-5-1-6 1m6-3c3-2 5-1 6 1"/></svg>',
    gift: '<svg viewBox="0 0 24 24"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3 9h18M12 9v11M12 9c-1.5-3-5-4-5-1.5S10 9 12 9Zm0 0c1.5-3 5-4 5-1.5S14 9 12 9Z"/></svg>',
    canal: '<svg viewBox="0 0 24 24"><path d="M5 20V9l2.5-3L10 9v11M14 20V9l2.5-3L19 9v11"/><path d="M3 20h18M7.5 12v2M16.5 12v2M10 14h4"/></svg>',
    bridge: '<svg viewBox="0 0 24 24"><path d="M9 20 11 3l2 17"/><path d="M11 5 3 15M11 5l10 10M11 9 5 15M11 9l8 6M2 15h20M3 20h18"/></svg>',
    hearts: '<svg viewBox="0 0 24 24"><path d="M14 9c0 3.5-5.5 7.5-5.5 7.5S3 12.5 3 9c0-1.8 1.3-3 3-3 1.2 0 2 .7 2.5 1.6C9 6.7 9.8 6 11 6c1.7 0 3 1.2 3 3Z"/><path d="M15.5 11.5c.5-.8 1.3-1.5 2.5-1.5 1.7 0 3 1.2 3 3 0 3.5-5.5 7.5-5.5 7.5s-1.6-1.2-3-2.8"/></svg>',
    mask: '<svg viewBox="0 0 24 24"><path d="M4 5c3 1.5 6 1.5 9 0v6c0 3.5-2 6-4.5 6S4 14.5 4 11Z"/><path d="M6.5 9h.01M10.5 9h.01M6.5 13c1.3 1 2.7 1 4 0"/><path d="M15 9c1.7.8 3.3.8 5 0v5c0 3-1.7 5-4 5-1 0-1.9-.4-2.6-1.1"/></svg>'
  };
  const themeIconMarkup = (handle) => THEME_ICONS[THEME_ICON_BY_HANDLE[normalized(handle).replace(/\s+/g, '-')]] || THEME_ICONS.sparkle;
  const DEFAULT_PRODUCT_ORDER = [
    'annie-mg-schmidt',
    'arnon-grunberg-tara',
    'johan-cruijff-elk-nadeel-heb-zen-voordeel',
    'louis-couperus-de-vuurvliegjes',
    'levi-weemoedt-propria-cures',
    'arthur-japin-het-lied-van-de-moeder',
    'adriaan-van-dis-het-laatste-boeket',
    'cees-nooteboom',
    'marieke-lucas-rijneveld-de-verdriethond',
    'herman-brusselmans-vragen-van-liefde',
    'jan-cremer-kornblumenblau',
    'jules-deelder',
    'louis-van-gaal-der-tod-oder-die-gladiolen',
    'marga-minco',
    'willem-wilmink-ben-ali-libi',
    'drs-p-dodenrit',
    'matchboox-multatuli-serie',
    'joost-zwagerman-die-overvloed',
    'andre-kuipers',
    'ronald-giphart',
    'hans-dorrestijn-de-toekomst',
    'daphne-deckers',
    'philip-freriks-kat-van-kaboel',
    'ramses-shaffy-zing-vecht-huil-bid-lach-werk-en',
    'jan-mulder-ware-liefde',
    'ramsey-nasr',
    'stef-bos-hoe-valt-een-schrijver-uit-de-trein',
    'fokke-en-sukke',
    'boudewijn-de-groot',
    'kader-abdolah',
    'gerrit-komrij',
    'tommy-wieringa',
    'aaf-brandt-corstius-banaantje',
    'henny-vrienten',
    'susan-smit-86',
    'stine-jensen',
    'hanneke-groenteman-wolkenjacht',
    'marion-pauw-45',
    'anna-enquist-alt',
    'm-vasalis-sotto-voce',
    'abdelkader-benali-ramen-en-deuren',
    'bert-wagendorp-digue-ventoux',
    'joke-van-leeuwen-interieur',
    'peter-de-wit',
    'wilfried-de-jong-droge-keel',
    'henk-spaan',
    'sylvia-witteman-minestrone',
    'hanna-bervoets-jurk',
    'exclusieve-ezels-serie',
    'nelleke-noordervliet-schrijver-in-frankrijk',
    'marion-bloem-een-lege-tas',
    'c-buddingh',
    'jc-bloem',
    'jan-campert',
    'leo-vroman-oorlogsserie',
    'jma-biesheuvel',
    'charlotte-mutsaers-sodom-revisited',
    'k-schippers-op-een-dag',
    'heere-heeresma-serie',
    'sjoerd-kuyper-de-heks-in-je-hoofd',
    'ted-van-lieshout-het-woordje-liefde',
    'tjibbe-veldkamp',
    'yvonne-kroonenberg-ballade-voor-de-zeedijk',
    'kristien-hemmerechts',
    'hafid-bouazza-maqame-xli',
    'annemarie-oster-actrice',
    'sophie-van-der-stap-orlando',
    'elle-van-rijn-sam-drukker',
    'marion-van-de-coolwijk-beeld-en-taal',
    'pieter-steinz-van-muggen-en-mammoeten',
    'jan-hanlo-serie',
    'herman-pieter-de-boer-de-bruid',
    'trijntje-fop-op-een-aal',
    'vic-van-de-reijt-de-toekomst-van-elsschot',
    'over-harry-mulisch-de-revolutionair',
    'anne-frank-serie',
    'annie-mg-schmidt-collection',
    'johan-cruijff-als-wij-de-bal-hebben',
    'facing-john',
    'louis-van-gaal-ben-ik-nu-degene-die-zo-slim-is',
    'annie-mg-schmidt-ik-zou-je-het-liefste-in-een-doosje-willen-doen',
    'johan-cruijff-ik-hou-van-werken',
    'paul-mccartney-cadeauboek',
    'louis-van-gaal-de-weg-naar-succes-is-altijd-onder-constructie',
    'schmidt-eenentwintig-poezen',
    'johan-cruijff-serie',
    'facing-paul',
    'louis-van-gaal-serie',
    'schmidt-ribbeltjeskat',
    'johan-cruijff-voordat-ik-een-fout-maak',
    'facing-elvis-presley',
    'louis-van-gaal-another-cook',
    'schmidt-schore-en-goes',
    'ramses-shaffy-het-is-stil-in-amsterdam',
    'facing-mick-jagger',
    'gk-van-het-reve',
    'remco-campert-de-bloem',
    'bekende-schrijvers-over-katten-1',
    'facing-amy-winehouse',
    'gerrit-kouwenaar-en-de-bijenkorf',
    'deborah-campert-serie',
    'nop-maas-hermans',
    'remco-campert',
    'arnon-grunberg-de-pool-boy',
    'facing-jimi-hendrix',
    'felix-rottenberg-en-de-wolkenkrabber',
    'facing-chuck-berry',
    'drs-p-serie',
    'facing-keith-richard',
    'theodor-holman-en-de-bijenkorf',
    'collection-c-buddingh',
    'trijntje-fop-op-een-grasmus',
    'facing-janis-joplin',
    'hanny-michaelis-en-de-wolkenkrabber',
    'bekende-schrijvers-over-katten-2',
    'ramses-shaffy-serie',
    'facing-jim-morrison',
    'piet-schreuders-en-de-wolkenkrabber',
    'remco-campert-oorlogsserie',
    'elisa-pesapane-serie-1',
    'facing-george',
    'facing-little-richard',
    'drs-p-het-trapportaal',
    'buddingh-de-opvliegende-man',
    'facing-ringo-starr',
    'max-de-jong-en-de-bijenkorf',
    'trijntje-fop-op-een-made',
    'reve-en-de-dood',
    'nescio-in-bergen-serie',
    'cockys-soepen-serie',
    'ramses-shaffy-sammy',
    'louis-gauthier-serie',
    'facing-charlie-watts',
    'drs-p-oost-groningen',
    'facing-jerry-lee-lewis',
    'facing-ron-wood',
    'buddingh-kachel',
    'trijntje-fop-op-twee-slakken',
    'vier-grote-schrijvers',
    'facing-mick-keith-ron-charlie',
    'bijenkorf-serie',
    'liefde-van-toen-serie',
    'louis-van-gaal-verzameld-werk',
    'beroemde-clowns-serie',
    'ramses-shaffy-we-zullen-doorgaan',
    'oorlogsserie',
    'volkskrant-collectie-2',
    'de-club-van-27-serie',
    'willem-wilmink-serie',
    'drs-p-veerpont',
    'volkskrant-collectie-1',
    'fantastische-vogels-serie',
    'elisa-pesapane-serie-2-de-toekomst',
    'propria-cures-serie',
    'kinderserie-1',
    'hans-vervoort-serie',
    'sam-drukker-serie',
    'kinderboeken-serie-2',
    'm-vasalis-serie',
    'kunst-in-bergen-serie',
    'bob-polak-mensje-van-keulen-propria-cures',
    'limerick',
    'jc-bloem-serie',
    'lichamelijke-oefening-serie',
    'leo-vroman-zodra',
    'jma-biesheuvel-collection',
    'trijntje-fop-serie',
    'bob-polak-lang-leve-ons-oranjehuis',
    'nop-maas-wiener',
    'christophe-vekeman-alles-voor-niets',
    'peter-zilahy-the-news',
    'christopher-smart-serie',
    'tania-heimans',
    'bies-van-ede',
    'the-fab-four-serie',
    'facing-rock-n-roll',
    'de-amsterdamse-gebouwenserie-de-wolkenkrabber',
    'studentenvoer-foodbox-serie',
  ];
  const cleanIllustratorTitle = (value) => {
    const title = String(value || '').trim();
    const parts = title.split(/\s+[–—]\s+/);
    if (parts.length > 1 && /(illustraties?|beelden?|kunst|tekeningen?|aquarellen?|portretten?|schilderijen?|vormgeving|typografie)/i.test(parts[0])) {
      return parts.slice(1).join(' – ');
    }
    return title;
  };
  const isIllustratorSku = (product) => (product?.variants || []).some((variant) => /\s[BDEFHKL]$/i.test(String(variant?.sku || '').trim())) || [].concat(product?.tags || []).some((tag) => /^(Illustrator|Vormgever|Alternatieve)-editie$/.test(String(tag).trim()));
  const visualLineSignature = (product) => {
    const title = String(product?._mbDisplayTitle || product?.title || '');
    const author = String(product?._mbCreator || product?._mbAuthors?.join(', ') || '');
    const titleLines = Math.max(1, Math.ceil(title.length / 29));
    const authorLines = author ? Math.max(1, Math.ceil(author.length / 34)) : 0;
    return (titleLines * 100) + authorLines;
  };
  const sortByVisualLines = (items) => [...items].sort((a, b) => visualLineSignature(a) - visualLineSignature(b) || collator.compare(a.title, b.title));
  const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const duplicateStopwords = new Set('de het een en of om op in van voor met aan bij als is zijn was waren wordt worden werd die dat dit deze er te tot uit uw u je jij hij zij wij ze hem haar hen hun ook nog wel al dan maar door over naar niet geen heel erg meer minder veel ieder iedere iemand iets zich zelf eigen'.split(' '));
  const sentenceTokens = (sentence) => new Set(normalized(sentence)
    .replace(/[^a-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter((word) => word.length > 2 && !duplicateStopwords.has(word)));
  const repeatedSentence = (sentence, earlierSentences) => {
    const key = normalized(sentence).replace(/[^a-z0-9]/g, '');
    const tokens = sentenceTokens(sentence);
    return earlierSentences.some((earlier) => {
      const earlierKey = normalized(earlier).replace(/[^a-z0-9]/g, '');
      if (key === earlierKey) return true;
      if (/\?$/.test(sentence.trim()) !== /\?$/.test(earlier.trim())) return false;
      const earlierTokens = sentenceTokens(earlier);
      const smallest = Math.min(tokens.size, earlierTokens.size);
      if (smallest < 4) return false;
      const shared = [...tokens].filter((token) => earlierTokens.has(token)).length;
      return shared >= 4 && shared / smallest >= 0.60;
    });
  };
  const displayTitle = (title, product) => {
    if (product?.handle === 'de-club-van-27-serie') return 'De club van 27 Serie';
    if (product?.handle === 'christopher-smart-serie') return 'Smarts Kattenserie';
    let result = String(title || '').trim();
    const creators = [product?._mbCreator, ...(product?._mbAuthors || []), product?.caption].filter(Boolean);
    creators.forEach((creator) => {
      result = result.replace(new RegExp(`^${escapeRegExp(creator)}\\s+(?:illustraties?|beelden?|kunst|tekeningen?|aquarellen?|portretten?|schilderijen?|vormgeving|typografie)\\s*[–—-]\\s*`, 'i'), '').trim();
      result = result.replace(new RegExp(`^${escapeRegExp(creator)}\\s*[–—-]\\s*`, 'i'), '').trim();
    });
    return result;
  };

  /* Gebruik dezelfde verhaalselectie als in de carrousel 'Uitgelicht':
     productinformatie en verkooptekst vallen weg, de inhoud van het boekje blijft over. */
  const storyOnly = (html, title) => {
    const textHost = document.createElement('div');
    textHost.innerHTML = html || '';
    textHost.querySelectorAll('style, script').forEach((node) => node.remove());
    const boilerplate = /(luciferdoos|geschenkdoos|harmonicaboek|harmonica-?boek|miniatuurboek|uitvouwbare|leporello|\bpagina['’]?s?\b|handgemaakt|zelfstandige\s+(?:MatchBoox[- ]?)?uitgave|losse uitgave|afzonderlijke uitgave|los verkrijgbaar|complete reeks|onderdeel van|kenmerken)/i;
    const titlePattern = title ? new RegExp(`^${escapeRegExp(title)}\\s*[·:–—-]*\\s*[.!?…]*$`, 'i') : null;
    const intro = textHost.querySelector('.mb-product-intro');
    const introParagraphs = intro
      ? [...intro.children].filter((node) => node.matches('p:not(.mb-intro-kicker):not(.mb-intro-title)'))
      : [];
    const nodeText = (nodes) => [...nodes]
      .map((node) => node.textContent.replace(/\s+/g, ' ').trim())
      .filter(Boolean);
    const splitSentences = (parts) => (parts.length ? parts : [textHost.textContent])
      .flatMap((part) => {
        const protectedInitials = part
          .replace(/\b(Drs|drs|Dr|dr|Dhr|dhr|Mevr|mevr|Prof|prof|Mr|mr)\./g, '$1\u2024')
          .replace(/\b([A-Z])\./g, '$1\u2024');
        return (protectedInitials.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [])
          .map((sentence) => sentence.replace(/\u2024/g, '.'));
      });
    const cleanSentences = (parts) => splitSentences(parts)
      .map((sentence) => sentence.trim())
      .filter((sentence) => sentence
        && sentence.length > 35
        && !(titlePattern && titlePattern.test(sentence))
        && !boilerplate.test(sentence))
      .map((sentence) => sentence
        .replace(/\b(?:dit|het)\s+(?:handgemaakte\s+)?MatchBoox(?:-miniatuurboek)?\b/gi, 'Dit verhaal')
        .replace(/\been\s+handgemaakt\s+miniatuurboek\s+over\b/i, 'Een verhaal over'))
      .map((sentence) => /[.!?…]["')\]]?$/.test(sentence) ? sentence : `${sentence}.`);
    let cleaned = cleanSentences(nodeText(introParagraphs.length ? introParagraphs : textHost.querySelectorAll('p, li')));
    if (introParagraphs.length && cleaned.join(' ').split(/\s+/).filter(Boolean).length < 40) {
      const firstPanel = textHost.querySelector('.mb-product-panel');
      const panelStory = firstPanel ? cleanSentences(nodeText(firstPanel.querySelectorAll('p'))) : [];
      if (panelStory.length) cleaned = panelStory;
    }
    const story = [];
    cleaned.forEach((sentence) => {
      if (!repeatedSentence(sentence, story)) story.push(sentence);
    });
    const summary = [];
    let wordCount = 0;
    for (const sentence of story) {
      const sentenceWords = sentence.split(/\s+/).filter(Boolean).length;
      if (summary.length && wordCount + sentenceWords > 105) break;
      summary.push(sentence);
      wordCount += sentenceWords;
      if (summary.length === 4) break;
    }
    return summary.join(' ');
  };

  const SERIES_SUMMARY_OVERRIDES = {
    'the-fab-four-serie': 'Eric J. Coolen portretteerde de vier Beatles op verschillende leeftijden. Elk boekje volgt één bandlid van zijn jonge jaren tot zijn latere leven en toont de veranderingen in gezicht, kapsel, kleding en uitstraling. Samen vormen de vier getekende levenslijnen een bijzonder tijdsdocument.',
    'de-club-van-27-serie': 'Vier muzikanten, vier levensverhalen. Eric J. Coolen verbeeldde Jimi Hendrix, Janis Joplin, Jim Morrison en Amy Winehouse in vier getekende biografieën. Zij worden gerekend tot de Club van 27: invloedrijke musici die op 27-jarige leeftijd overleden. Samen brengen de boekjes hun levens en nalatenschap in beeld.',
    'de-amsterdamse-gebouwenserie-de-wolkenkrabber': 'Deze complete serie brengt verhalen samen over Willem Frederik Hermans, Hanny Michaelis, Felix Rottenberg en Piet Schreuders in relatie tot het markante Twaalfverdiepingenhuis aan het Victorieplein. Elk boekje belicht één bekende naam en De Wolkenkrabber vanuit een eigen invalshoek. Samen plaatsen de vier verhalen het gebouw in persoonlijke geschiedenissen en in de geschiedenis van Amsterdam.'
  };
  const SERIES_CREATOR_OVERRIDES = {
    'de-amsterdamse-gebouwenserie-de-wolkenkrabber': 'Over Willem Frederik Hermans, Hanny Michaelis, Felix Rottenberg en Piet Schreuders'
  };

  /*
   * Vastgestelde fondsvolgorde: serie links, daarna LB, RB, LO en RO.
   * Alleen deze gecontroleerde relaties worden automatisch uitgebreid.
   */
  const SERIES_GROUPS = {
    'volkskrant-collectie-1': ['ronald-giphart', 'sylvia-witteman-minestrone', 'aaf-brandt-corstius-banaantje', 'bert-wagendorp-digue-ventoux'],
    'kinderserie-1': ['sjoerd-kuyper-de-heks-in-je-hoofd', 'aaf-brandt-corstius-banaantje', 'tjibbe-veldkamp', 'sophie-van-der-stap-orlando'],
    'volkskrant-collectie-2': ['arnon-grunberg-de-pool-boy', 'peter-de-wit', 'hanna-bervoets-jurk', 'jan-mulder-ware-liefde'],
    'louis-gauthier-serie': ['remco-campert', 'charlotte-mutsaers-sodom-revisited', 'jules-deelder', 'gerrit-komrij'],
    'sam-drukker-serie': ['elle-van-rijn-sam-drukker', 'tania-heimans', 'marion-pauw-45', 'susan-smit-86'],
    'deborah-campert-serie': ['remco-campert-de-bloem', 'adriaan-van-dis-het-laatste-boeket', 'jan-cremer-kornblumenblau', 'joost-zwagerman-die-overvloed'],
    'elisa-pesapane-serie-1': ['nelleke-noordervliet-schrijver-in-frankrijk', 'arnon-grunberg-tara', 'kader-abdolah', 'louis-couperus-de-vuurvliegjes'],
    'vier-grote-schrijvers': ['reve-en-de-dood', 'over-harry-mulisch-de-revolutionair', 'nop-maas-hermans', 'nop-maas-wiener'],
    'kinderboeken-serie-2': ['marion-van-de-coolwijk-beeld-en-taal', 'hanneke-groenteman-wolkenjacht', 'kristien-hemmerechts', 'stine-jensen'],
    'elisa-pesapane-serie-2-de-toekomst': ['pieter-steinz-van-muggen-en-mammoeten', 'vic-van-de-reijt-de-toekomst-van-elsschot', 'hans-dorrestijn-de-toekomst', 'hafid-bouazza-maqame-xli'],
    'drs-p-serie': ['drs-p-het-trapportaal', 'drs-p-dodenrit', 'drs-p-oost-groningen', 'drs-p-veerpont'],
    'collection-c-buddingh': ['limerick', 'buddingh-kachel', 'buddingh-de-opvliegende-man', 'c-buddingh'],
    'propria-cures-serie': ['bob-polak-mensje-van-keulen-propria-cures', 'fokke-en-sukke', 'henk-spaan', 'levi-weemoedt-propria-cures'],
    'annie-mg-schmidt-collection': ['annie-mg-schmidt', 'schmidt-schore-en-goes', 'schmidt-eenentwintig-poezen', 'schmidt-ribbeltjeskat'],
    'johan-cruijff-serie': ['johan-cruijff-elk-nadeel-heb-zen-voordeel', 'johan-cruijff-als-wij-de-bal-hebben', 'johan-cruijff-ik-hou-van-werken', 'johan-cruijff-voordat-ik-een-fout-maak'],
    'oorlogsserie': ['remco-campert-oorlogsserie', 'jan-campert', 'marga-minco', 'leo-vroman-oorlogsserie'],
    'ramses-shaffy-serie': ['ramses-shaffy-sammy', 'ramses-shaffy-het-is-stil-in-amsterdam', 'ramses-shaffy-we-zullen-doorgaan', 'ramses-shaffy-zing-vecht-huil-bid-lach-werk-en'],
    'the-fab-four-serie': ['facing-john', 'facing-paul', 'facing-george', 'facing-ringo-starr'],
    'louis-van-gaal-serie': ['louis-van-gaal-ben-ik-nu-degene-die-zo-slim-is', 'louis-van-gaal-de-weg-naar-succes-is-altijd-onder-constructie', 'louis-van-gaal-another-cook', 'louis-van-gaal-der-tod-oder-die-gladiolen'],
    'trijntje-fop-serie': ['trijntje-fop-op-een-aal', 'trijntje-fop-op-een-grasmus', 'trijntje-fop-op-een-made', 'trijntje-fop-op-twee-slakken'],
    'de-club-van-27-serie': ['facing-amy-winehouse', 'facing-jimi-hendrix', 'facing-janis-joplin', 'facing-jim-morrison'],
    'facing-mick-keith-ron-charlie': ['facing-mick-jagger', 'facing-keith-richard', 'facing-ron-wood', 'facing-charlie-watts'],
    'facing-rock-n-roll': ['facing-elvis-presley', 'facing-chuck-berry', 'facing-little-richard', 'facing-jerry-lee-lewis'],
    'bijenkorf-serie': ['theodor-holman-en-de-bijenkorf', 'max-de-jong-en-de-bijenkorf', 'gerrit-kouwenaar-en-de-bijenkorf', 'gk-van-het-reve'],
    'de-amsterdamse-gebouwenserie-de-wolkenkrabber': ['hanny-michaelis-en-de-wolkenkrabber', 'felix-rottenberg-en-de-wolkenkrabber', 'piet-schreuders-en-de-wolkenkrabber']
  };
  window.MatchBooxSeriesGroups = SERIES_GROUPS;

  const readData = (root) => {
    const scope = root.closest('.mb-home, .mb-global-footer__browse') || document;
    const script = scope.querySelector('script[id^="MatchBooxCarouselData-"]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  };

  const readGroups = (root) => {
    const script = root.querySelector('[data-mb-discovery-groups]');
    let groups = { authors: {}, illustrators: {} };
    if (script) {
      try { groups = JSON.parse(script.textContent); } catch (error) { /* Gebruik lege groepen. */ }
    }

    /*
     * De auteurs worden uitsluitend uit de actuele fondslijst opgebouwd.
     * Zo worden personen waar een boek over gaat nooit als auteur getoond.
     */
    const fondsAuthors = root.querySelector('[data-mb-fonds-authors]');
    if (fondsAuthors) {
      try { groups.authors = JSON.parse(fondsAuthors.textContent); } catch (error) { /* Behoud de bestaande fallback. */ }
    }
    const additions = root.querySelector('[data-mb-fonds-author-additions]');
    if (additions) {
      try {
        Object.entries(JSON.parse(additions.textContent)).forEach(([name, handles]) => {
          groups.authors[name] = [...new Set([...(groups.authors[name] || []), ...handles])];
        });
      } catch (error) { /* Behoud de gecontroleerde fondslijst. */ }
    }
    return groups;
  };

  const canonicalProductHandle = (handle) => ({
    'deborah-campert-campert': 'deborah-campert-de-bloem',
    
  }[handle] || handle);


  /* Toont bij een zoekopdracht op een maker alleen diens eigen editie en niet
     ook nog de auteursversie met hetzelfde MB-nummer ernaast. */
  const mbSkuInfoCache = new Map();
  const mbSkuInfo = (handle) => {
    if (!mbSkuInfoCache.has(handle)) {
      mbSkuInfoCache.set(handle, fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          const sku = String(product?.variants?.[0]?.sku || '').trim();
          const match = sku.match(/^MB\s*(\d+)(?:\s*([A-Z]+))?$/i);
          return match ? { number: Number(match[1]), letter: (match[2] || '').toUpperCase(), series: /serie/i.test(String(product?.type || '')) } : { number: -1, letter: '', series: /serie/i.test(String(product?.type || '')) };
        })
        .catch(() => null));
    }
    return mbSkuInfoCache.get(handle);
  };
  const mbDropAuthorDuplicates = async (items) => {
    const infos = await Promise.all(items.map((item) => (item?.handle ? mbSkuInfo(item.handle) : Promise.resolve(null))));
    const editionNumbers = new Set(infos.filter((info) => info && info.letter).map((info) => info.number));
    const seen = new Set();
    const kept = [];
    items.forEach((item, index) => {
      const info = infos[index];
      if (info && info.number !== -1 && !info.letter && editionNumbers.has(info.number)) return;
      if (!item?.handle || seen.has(item.handle)) return;
      seen.add(item.handle);
      kept.push({ item, info: info || { number: -1, letter: '', series: false }, index });
    });
    /* Hoogste MB-nummer eerst, daarna aflopend. */
    kept.sort((left, right) => (right.info.number - left.info.number)
      || left.info.letter.localeCompare(right.info.letter)
      || (left.index - right.index));
    return kept.map((entry) => entry.item);
  };

  /* Hoogste MB-nummer eerst, daarna aflopend. */
  const mbSortNewest = async (items) => {
    const list = (items || []).filter(Boolean);
    const infos = await Promise.all(list.map((item) => (item?.handle ? mbSkuInfo(item.handle) : Promise.resolve(null))));
    return list.map((item, index) => ({ item, info: infos[index] || { number: -1, letter: '', series: false }, index }))
      .sort((left, right) => (right.info.number - left.info.number)
        || left.info.letter.localeCompare(right.info.letter)
        || (left.index - right.index))
      .map((entry) => entry.item);
  };
  const makeCatalog = (data) => {
    const products = new Map();
    const add = (item, theme) => {
      if (!item?.handle) return;
      const handle = canonicalProductHandle(item.handle);
      const existing = products.get(handle);
      const saved = existing || { ...item, handle, themes: [] };
      if (handle !== item.handle) saved.url = `/products/${handle}`;
      saved.kind = ['facing-mick-keith-ron-charlie', 'bekende-schrijvers-over-katten-1', 'bekende-schrijvers-over-katten-2', 'annie-mg-schmidt-ik-zou-je-het-liefste-in-een-doosje-willen-doen'].includes(handle) ? 'series' : (saved.kind || (/serie/i.test(`${saved.title} ${saved.caption}`) ? 'series' : 'loose'));
      if (theme && !saved.themes.includes(theme)) saved.themes.push(theme);
      products.set(handle, saved);
    };
    (data.large || []).forEach((item) => add(item));
    (data.categories || []).forEach((category) => (category.items || []).forEach((item) => add(item, category.name)));
    return [...products.values()];
  };

  const firstCover = async (product) => {
    const cacheKey = `${product.handle}:first`;
    if (coverCache.has(cacheKey)) return coverCache.get(cacheKey);
    const directUrl = product.url || `/products/${product.handle}`;
    /* Gebruik uitsluitend het product met deze exacte Shopify-URL. Nooit via
       een zoekresultaat of oud themabestand naar een andere afbeelding uitwijken. */
    const loadProduct = () => fetch(`${directUrl}.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('Product niet gevonden')));
    const promise = loadProduct()
      .then((data) => {
        const variant = data.variants?.find((candidate) => candidate.available) || data.variants?.[0];
        return {
          /* data.images[0] is de actuele Afbeelding 1 in Shopify. */
          src: data.images?.[0]?.src || data.images?.[0] || '',
          title: data.title || product.title,
          description: data.description || '',
          price: variant?.price ?? data.price,
          url: data.handle ? `/products/${data.handle}` : directUrl,
          isIllustrator: isIllustratorSku(data),
          live: true
        };
      })
      .catch(() => ({ src: '', title: '', url: directUrl, isIllustrator: Boolean(product._mbIllustratorVersion), live: false }));
    coverCache.set(cacheKey, promise);
    return promise;
  };

  const observeCovers = (grid) => {
    const cards = [...grid.querySelectorAll('[data-product-handle]')].filter((el) => el._mbProduct);
    const load = async (card) => {
      if (card.dataset.coverLoaded === 'true') return;
      card.dataset.coverLoaded = 'true';
      const product = card._mbProduct;
      if (!product || !product.handle) return;
      const cover = await firstCover(product);
      if (!cover.live) return;
      const wantsIllustratorVersion = Boolean(product._mbIllustratorVersion);
      if (!product._mbSkipVersionFilter && wantsIllustratorVersion && !cover.isIllustrator) {
        card.remove();
        return;
      }
      if (!card.isConnected) return;
      const coverHost = card.querySelector('.mb-discovery__cover');
      if (coverHost && cover.src) {
        const image = coverHost.querySelector('img') || document.createElement('img');
        image.onerror = () => { image.onerror = null; image.remove(); };
        image.src = cover.src;
        image.alt = `Omslag van ${cover.title}${product.caption ? ` — ${product.caption}` : ''}`;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.addEventListener('load', () => coverHost.classList.add('is-loaded'), { once: true });
        if (!image.parentElement) coverHost.append(image);
        if (image.complete) coverHost.classList.add('is-loaded');
      }
      const title = card.querySelector('strong');
      if (title) {
        title.textContent = displayTitle(cover.title, product);
        title.hidden = false;
      }
      const description = card.querySelector('.mb-discovery__featured-description');
      if (description && (cover.description || SERIES_SUMMARY_OVERRIDES[product.handle])) {
        const story = SERIES_SUMMARY_OVERRIDES[product.handle]
          || storyOnly(cover.description, cover.title || product.title);
        description.textContent = story;
        description.hidden = !story;
      }
      const cart = card.querySelector('[data-mb-quick-add]');
      let price = cart?.querySelector('.mb-price-cart-button__price');
      if (cart && !price) {
        price = document.createElement('span');
        price.className = 'mb-price-cart-button__price';
        cart.prepend(price);
      }
      if (cart && price && cover.price != null) {
        const formattedPrice = formatMoney(cover.price);
        price.textContent = formattedPrice;
        cart.dataset.productPrice = formattedPrice;
      }
      if (cover.url) {
        if (card.matches('a')) card.href = cover.url;
        card.querySelectorAll('[data-mb-product-link]').forEach((link) => { link.href = cover.url; });
      }
    };
    if (!('IntersectionObserver' in window)) { cards.forEach(load); return; }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      load(entry.target);
    }), { rootMargin: '300px' });
    cards.forEach((card) => observer.observe(card));
  };

  const productCard = (product, featured = false) => {
    const card = document.createElement(featured ? 'article' : 'a');
    card.className = `mb-discovery__card${featured ? ' mb-discovery__featured-card mb40__featured-slide is-active' : ''}`;
    const productUrl = product.url || `/products/${product.handle}`;
    if (!featured) card.href = productUrl;
    card.dataset.productHandle = product.handle;
    card._mbProduct = product;
    const cover = document.createElement('div');
    cover.className = 'mb-discovery__cover';
    const title = document.createElement('strong');
    title.textContent = displayTitle(product.title, product);
    title.hidden = false;
    /* Gebruik eerst de gecontroleerde fondskoppeling en daarna de auteursnaam uit de catalogusdata. */
    const captionText = SERIES_CREATOR_OVERRIDES[product.handle]
      || product._mbCreator
      || (product._mbAuthors?.length ? product._mbAuthors.join(', ') : '')
      || (product.kind !== 'series' ? product.caption : '');
    const caption = document.createElement('span');
    caption.textContent = captionText && normalized(captionText) !== normalized(product.title) ? captionText : '\u00a0';
    if (featured) {
      const imageLink = document.createElement('a');
      imageLink.className = 'mb-discovery__featured-image-link mb40__featured-image';
      imageLink.href = productUrl;
      imageLink.dataset.mbProductLink = '';
      imageLink.setAttribute('aria-label', `Bekijk ${product.title}`);
      imageLink.append(cover);
      const copy = document.createElement('div');
      copy.className = 'mb-discovery__featured-copy mb40__featured-copy';
      const titleLink = document.createElement('a');
      titleLink.className = 'mb-discovery__featured-title-link';
      titleLink.href = productUrl;
      titleLink.dataset.mbProductLink = '';
      titleLink.append(title);
      const titleHeading = document.createElement('h2');
      titleHeading.append(titleLink);
      const action = document.createElement('a');
      action.className = 'mb-discovery__featured-action mb40__button mb40__button--solid mb40__featured-cta';
      action.href = productUrl;
      action.dataset.mbProductLink = '';
      action.textContent = 'Bekijk product';
      const cart = document.createElement('button');
      cart.type = 'button';
      cart.className = 'mb-quick-add mb-discovery__featured-cart mb-price-cart-button';
      cart.dataset.mbQuickAdd = '';
      cart.dataset.mbQuickAddLabel = 'Toevoegen winkelmandje';
      cart.dataset.productHandle = product.handle;
      cart.dataset.defaultLabel = 'Toevoegen winkelmandje';
      cart.setAttribute('aria-label', 'Toevoegen winkelmandje');
      cart.setAttribute('title', 'Toevoegen winkelmandje');
      cart.innerHTML = `<span class="mb-price-cart-button__price">Prijs laden…</span>${resultCartIcon}`;
      const actions = document.createElement('div');
      actions.className = 'mb-discovery__featured-actions';
      actions.append(action, cart);
      const description = document.createElement('p');
      description.className = 'mb-discovery__featured-description';
      description.dataset.mb40FeaturedDescription = '';
      description.hidden = true;
      caption.className = 'mb40__featured-maker';
      const mobileBack = document.createElement('button');
      mobileBack.type = 'button';
      mobileBack.className = 'mb-discovery__back-to-choices mb-discovery__mobile-slide-back';
      mobileBack.textContent = '↑ Terug naar keuzes';
      mobileBack.addEventListener('click', () => scrollBelowHeader(card.closest('.mb-discovery')));
      copy.append(titleHeading, caption, description, actions, mobileBack);
      card.append(imageLink, copy);
    } else {
      card.append(cover, title, caption);
    }
    return card;
  };

  const renderProducts = (host, products, heading, moreUrl = '', resultCount = products.length) => {
    host.closest('.mb-discovery__body')?.classList.add('has-choice-result');
    const listFooter = host.closest('.mb-discovery__body')?.querySelector('[data-mb-discovery-list-footer]');
    if (listFooter) listFooter.hidden = true;
    const previousHeight = host.hidden ? 0 : host.offsetHeight;
    if (previousHeight) host.style.minHeight = `${previousHeight}px`;
    host.classList.add('is-updating');
    host.replaceChildren();
    if (!products.length) {
      const empty = document.createElement('p');
      empty.className = 'mb-discovery__empty';
      empty.textContent = 'Voor deze keuze zijn nog geen producten gevonden.';
      host.append(empty);
      host.hidden = false;
      requestAnimationFrame(() => {
        host.classList.remove('is-updating');
        window.setTimeout(() => { host.style.minHeight = ''; }, 320);
      });
      return;
    }
    const head = document.createElement('div');
    head.className = 'mb-discovery__products-head';
    const title = document.createElement('h3');
    const featuredResults = !host.closest('.mb-discovery--recommendations-only');
    const count = document.createElement('span');
    count.className = 'mb-discovery__products-count';
    if (featuredResults) {
      title.textContent = `${heading} (${resultCount} ${resultCount === 1 ? 'uitgave' : 'uitgaven'})`;
      head.append(title);
      if (moreUrl) {
        const overview = document.createElement('a');
        overview.className = 'mb-discovery__products-overview';
        overview.href = moreUrl;
        overview.textContent = 'Bekijk de bijbehorende overzichtspagina';
        head.append(overview);
      }
    } else {
      title.textContent = heading;
      count.textContent = `${resultCount} ${resultCount === 1 ? 'uitgave' : 'uitgaven'}`;
      head.append(title, count);
    }
    const stage = document.createElement('div');
    stage.className = `mb-discovery__carousel ${featuredResults ? 'mb-discovery__carousel--featured' : 'mb-discovery__carousel--single-mobile'}`;
    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'mb-discovery__arrow mb-discovery__arrow--prev';
    previous.setAttribute('aria-label', 'Vorige resultaten');
    previous.textContent = '<';
    const grid = document.createElement('div');
    grid.className = 'mb-discovery__track';
    if (featuredResults ? products.length === 1 : products.length < 5) grid.classList.add('is-short');
    products.forEach((product) => grid.append(productCard(product, featuredResults)));
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'mb-discovery__arrow mb-discovery__arrow--next';
    next.setAttribute('aria-label', 'Volgende resultaten');
    next.textContent = '>';
    previous.hidden = products.length <= 1;
    next.hidden = products.length <= 1;
    stage.append(previous, grid, next);
    host.append(head, stage);
    const updateArrows = () => {
      const end = grid.scrollWidth - grid.clientWidth;
      previous.disabled = end <= 2 || grid.scrollLeft <= 2;
      next.disabled = end <= 2 || grid.scrollLeft >= end - 2;
    };
    previous.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' }));
    next.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' }));
    grid.addEventListener('scroll', updateArrows, { passive: true });
    requestAnimationFrame(updateArrows);
    if (featuredResults) {
      const footer = document.createElement('div');
      footer.className = 'mb-discovery__result-footer';
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'mb-discovery__back-to-choices';
      back.textContent = '↑ Terug naar keuzes';
      back.addEventListener('click', () => scrollBelowHeader(host.closest('.mb-discovery')));
      footer.append(back);
      host.append(footer);
    }
    host.hidden = false;
    observeCovers(grid);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      host.classList.remove('is-updating');
      window.setTimeout(() => { host.style.minHeight = ''; }, 320);
    }));
  };

  const arrangeAsSeries = (products, byHandle, expandMembers = true, allowedSeries = null) => {
    const requested = new Set(products.map((product) => product.handle));
    const memberToSeries = new Map();
    Object.entries(SERIES_GROUPS).forEach(([seriesHandle, members]) => {
      members.forEach((handle) => {
        if (!memberToSeries.has(handle)) memberToSeries.set(handle, seriesHandle);
      });
    });

    const relevantSeries = [];
    products.forEach((product) => {
      const seriesHandle = SERIES_GROUPS[product.handle] ? product.handle : memberToSeries.get(product.handle);
      if (seriesHandle && (!allowedSeries || allowedSeries.has(seriesHandle)) && !relevantSeries.includes(seriesHandle)) relevantSeries.push(seriesHandle);
    });

    const arranged = [];
    const added = new Set();
    const standaloneLoose = products.filter((product) => product.kind !== 'series' && !memberToSeries.has(product.handle));
    const authorSeen = new Set();
    const diverseLoose = [];
    const repeatedLoose = [];
    standaloneLoose.forEach((product) => {
      const author = normalized(product._mbCreator || product._mbAuthors?.[0] || '');
      if (author && !authorSeen.has(author)) {
        authorSeen.add(author);
        diverseLoose.push(product);
      } else {
        repeatedLoose.push(product);
      }
    });
    [...sortByVisualLines(diverseLoose), ...sortByVisualLines(repeatedLoose)]
      .forEach((product) => {
        arranged.push(product);
        added.add(product.handle);
      });
    const looseFallbacks = [...byHandle.values()].filter((product) => product.kind !== 'series');
    const fallbackStart = (handle) => [...handle].reduce((total, character) => total + character.charCodeAt(0), 0);
    relevantSeries.sort((a, b) => visualLineSignature(byHandle.get(a)) - visualLineSignature(byHandle.get(b)) || collator.compare(a, b)).forEach((seriesHandle) => {
      const group = [];
      const groupHandles = new Set([seriesHandle, ...(SERIES_GROUPS[seriesHandle] || [])]);
      const series = byHandle.get(seriesHandle);
      if (series && !added.has(series.handle)) {
        group.push(series);
        added.add(series.handle);
      }
      SERIES_GROUPS[seriesHandle].forEach((memberHandle) => {
        if (!expandMembers && !requested.has(memberHandle)) return;
        const member = byHandle.get(memberHandle) || products.find((product) => product.handle === memberHandle);
        if (member && !added.has(member.handle)) {
          group.push(member);
          added.add(member.handle);
        }
      });
      /* Vul auteursresultaten nooit aan met boekjes van een andere auteur.
         allowedSeries is aanwezig wanneer de selectie uit de auteurslijst komt. */
      if (expandMembers && !allowedSeries && group.length && group.length < 5) {
        let offset = fallbackStart(seriesHandle);
        let attempts = 0;
        while (group.length < 5 && looseFallbacks.length && attempts < looseFallbacks.length * 2) {
          const fallback = looseFallbacks[offset % looseFallbacks.length];
          offset += 1;
          attempts += 1;
          if (!fallback || added.has(fallback.handle) || groupHandles.has(fallback.handle) || group.some((item) => item.handle === fallback.handle)) continue;
          group.push(fallback);
          added.add(fallback.handle);
        }
      }
      arranged.push(...group);
    });

    sortByVisualLines(products).forEach((product) => {
      if (!added.has(product.handle)) {
        arranged.push(product);
        added.add(product.handle);
      }
    });
    return arranged;
  };

  const choiceButton = (label, action, type = '', iconKey = '') => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mb-discovery__choice';
    if (type) button.classList.add(`mb-discovery__choice--${type}`);
    if (type === 'collection') button.classList.add('mb-discovery__choice--theme');
    if (type === 'illustrator' || type === 'author') button.dataset.initial = String(label || '').trim().charAt(0).toUpperCase();
    button.setAttribute('aria-pressed', 'false');
    if (type === 'theme' || type === 'collection') {
      const icon = document.createElement('span');
      icon.className = 'mb-discovery__choice-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = themeIconMarkup(iconKey || label);
      button.append(icon);
    }
    const name = document.createElement('span');
    name.textContent = label;
    button.append(name);
    button.addEventListener('click', () => {
      const choiceHost = button.closest('[data-mb-discovery-choices]') || button.parentElement;
      const discoveryBody = choiceHost.closest('.mb-discovery__body');
      choiceHost.querySelectorAll('.mb-discovery__choice').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      /* Sluit de keuzelijst vóór het renderen. Zo kan een fout of late update in een
         productresultaat de lijst nooit zichtbaar laten staan. */
      choiceHost.hidden = true;
      choiceHost.setAttribute('aria-hidden', 'true');
      choiceHost.style.setProperty('display', 'none', 'important');
      discoveryBody?.classList.add('has-choice-result');
      action();
      const resultsHost = discoveryBody?.querySelector('[data-mb-discovery-products]');
      requestAnimationFrame(() => requestAnimationFrame(() => scrollBelowHeader(resultsHost)));
    });
    return button;
  };

  const setup = (root) => {
    if (root.dataset.mbDiscoveryReady === 'true') return;
    const data = readData(root);
    if (!data) return;
    root.dataset.mbDiscoveryReady = 'true';
    const configured = readGroups(root);
    configured.authors ||= {};
    configured.illustrators ||= {};
    const catalog = makeCatalog(data);
    const byHandle = new Map(catalog.map((item) => [item.handle, item]));
    const deBloem = byHandle.get('deborah-campert-de-bloem');
    if (deBloem) {
      
      byHandle.set('deborah-campert-campert', deBloem);
    }
    const ezelsSerie = byHandle.get('exclusieve-ezels-serie');
    if (ezelsSerie) ezelsSerie._mbAuthors = ['Mensje van Keulen'];
    const sottoVoce = byHandle.get('m-vasalis-sotto-voce');
    if (sottoVoce) sottoVoce.orientation = 'p';
    Object.entries(configured.authors || {}).forEach(([author, handles]) => {
      handles.forEach((handle) => {
        const item = byHandle.get(handle);
        if (!item) return;
        item._mbAuthors ||= [];
        if (!item._mbAuthors.includes(author)) item._mbAuthors.push(author);
      });
    });
    const authorGroups = Object.entries(configured.authors || {})
      .map(([name, handles]) => [name, handles.map((handle) => byHandle.get(handle)).filter(Boolean).map((item) => {
        item._mbSkipVersionFilter = true;
        return item;
      })])
      .filter(([, items]) => items.length)
      .sort(([a], [b]) => collator.compare(a, b));
    const illustratorGroups = Object.entries(configured.illustrators || {})
      .map(([name, items]) => {
        /* De groepsnaam komt rechtstreeks uit de gecontroleerde Shopify-fondslijst. */
        const displayName = String(name || '').trim();
        const products = items.filter((item) => item?.handle).map((item) => {
          const linkedProduct = byHandle.get(item.handle);
          const product = { ...(linkedProduct || {}), ...item };
          if (linkedProduct) {
            product.handle = linkedProduct.handle;
            product.url = linkedProduct.url || `/products/${linkedProduct.handle}`;
          }
          product._mbCreator = displayName;
          product._mbDisplayTitle = cleanIllustratorTitle(product.title);
          product._mbIllustratorVersion = !product._mbUseCanonicalProduct;
          return product;
        });
        return [displayName, products];
      })
      .filter(([, items]) => items.length)
      .sort(([a], [b]) => collator.compare(a, b));
    /* Vormgevers: hun eigen D- en E-edities, eerst de series en daarna de losse boekjes. */
    const designerGroups = Object.entries(configured.designers || {})
      .map(([name, items]) => {
        const displayName = String(name || '').trim();
        return [displayName, (items || []).filter((item) => item?.handle).map((item) => ({
          ...item,
          url: item.url || `/products/${item.handle}`,
          _mbCreator: displayName,
          _mbDisplayTitle: item.title,
          _mbIllustratorVersion: true,
          _mbSkipVersionFilter: true
        }))];
      })
      .filter(([, items]) => items.length)
      .sort(([a], [b]) => collator.compare(a, b));
    const seriesForAuthor = (author, products) => {
      const authorKey = normalized(author);
      const allowedSeries = new Set(Object.entries(SERIES_GROUPS)
        .filter(([, members]) => members.length && members.every((handle) => {
          const member = byHandle.get(handle);
          return member && (member._mbAuthors || []).some((name) => normalized(name) === authorKey);
        }))
        .map(([seriesHandle]) => seriesHandle));
      const isSeriesOfThisAuthorOnly = (product) => product.kind === 'series'
        && product._mbAuthors?.length === 1
        && normalized(product._mbAuthors[0]) === authorKey;
      /* Bob Polak heeft naast losse titels meerdere zelfstandige serie-uitgaven.
         Behoud voor hem daarom alle expliciet aan zijn fondslijst gekoppelde producten. */
      const filtered = authorKey === normalized('Bob Polak')
        ? [...products]
        : products.filter((product) => product.kind !== 'series'
          || allowedSeries.has(product.handle)
          || isSeriesOfThisAuthorOnly(product)
          || (authorKey === normalized('Christopher Smart') && product.handle === 'christopher-smart-serie'));
      allowedSeries.forEach((seriesHandle) => {
        const series = byHandle.get(seriesHandle);
        if (series && !filtered.some((product) => product.handle === seriesHandle)) filtered.push(series);
      });
      return { products: filtered, allowedSeries };
    };
    const subjectTitle = (value) => normalized(String(value || '')
      .replace(/^.*?\s*[–—]\s*/, '')
      .replace(/\s*\([^)]*\)\s*$/g, '')
      .replace(/[^a-z0-9]+/gi, ''));
    const sameSubject = (left, right) => left === right || left.startsWith(right) || right.startsWith(left);
    const seriesForIllustrator = (illustrator, products) => {
      const subjects = new Set(products.map((product) => subjectTitle(product.title)).filter(Boolean));
      const allowedSeries = new Set(Object.entries(SERIES_GROUPS)
        .filter(([, members]) => members.length >= 4 && members.every((handle) => {
          const member = byHandle.get(handle);
          const memberSubject = subjectTitle(member?.title);
          return memberSubject && [...subjects].some((subject) => sameSubject(subject, memberSubject));
        }))
        .map(([seriesHandle]) => seriesHandle));
      const withSeries = [...products];
      allowedSeries.forEach((seriesHandle) => {
        const series = byHandle.get(seriesHandle);
        if (!series || withSeries.some((product) => product.handle === seriesHandle)) return;
        withSeries.push({ ...series, _mbCreator: illustrator, _mbIllustratorVersion: false });
      });
      return { products: withSeries, allowedSeries };
    };
    const knownAuthorSeries = [
      'annie-mg-schmidt-collection',
      'm-vasalis-serie',
      'johan-cruijff-serie',
      'ramses-shaffy-serie',
      'willem-wilmink-serie',
      'matchboox-multatuli-serie',
      'jma-biesheuvel-collection',
      'drs-p-serie',
      'collection-c-buddingh',
      'jan-hanlo-serie',
      'jc-bloem-serie',
      'heere-heeresma-serie',
      'trijntje-fop-serie',
      'louis-van-gaal-serie',
      'christopher-smart-serie',
      'exclusieve-ezels-serie',
      'cockys-soepen-serie'
    ];
    const knownRank = new Map(knownAuthorSeries.map((handle, order) => [handle, order]));
    const seriesAtTheEnd = new Set([
      'hans-vervoort-serie',
      'nescio-in-bergen-serie',
      'bob-polak-lang-leve-ons-oranjehuis',
      'fantastische-vogels-serie',
      'liefde-van-toen-serie',
      'lichamelijke-oefening-serie',
      'the-fab-four-serie',
      'de-club-van-27-serie',
      'facing-mick-keith-ron-charlie',
      'kunst-in-bergen-serie',
      'de-amsterdamse-gebouwenserie-de-wolkenkrabber',
      'bijenkorf-serie',
      'facing-rock-n-roll',
      'bekende-schrijvers-over-katten-1',
      'bekende-schrijvers-over-katten-2'
    ]);
    const series = catalog.filter((item) => item.kind === 'series').sort((left, right) => {
      const leftKnown = knownRank.has(left.handle);
      const rightKnown = knownRank.has(right.handle);
      if (leftKnown || rightKnown) {
        if (!leftKnown) return 1;
        if (!rightKnown) return -1;
        return knownRank.get(left.handle) - knownRank.get(right.handle);
      }
      const leftLast = seriesAtTheEnd.has(left.handle);
      const rightLast = seriesAtTheEnd.has(right.handle);
      if (leftLast !== rightLast) return leftLast ? 1 : -1;
      return visualLineSignature(left) - visualLineSignature(right) || collator.compare(left.title, right.title);
    });
    const body = root.querySelector('[data-mb-discovery-body]');
    const choices = root.querySelector('[data-mb-discovery-choices]');
    const productsHost = root.querySelector('[data-mb-discovery-products]');
    const searchResults = root.querySelector('[data-mb-discovery-search-results]');
    const tabs = [...root.querySelectorAll('[data-mb-discovery-tab]')];
    const listFooter = document.createElement('div');
    listFooter.className = 'mb-discovery__list-footer';
    listFooter.dataset.mbDiscoveryListFooter = '';
    listFooter.hidden = true;
    const listBack = document.createElement('button');
    listBack.type = 'button';
    listBack.className = 'mb-discovery__back-to-choices';
    listBack.textContent = '↑ Terug naar keuzes';
    listBack.addEventListener('click', () => scrollBelowHeader(root));
    listFooter.append(listBack);
    choices.insertAdjacentElement('afterend', listFooter);
    const renderSeriesResults = (host, products, heading, moreUrl = '', expandMembers = true) => {
      renderProducts(host, arrangeAsSeries(products, byHandle, expandMembers), heading, moreUrl, products.length);
    };
    const byNewest = (a, b) => Number(b.number || 0) - Number(a.number || 0);
    const bobPolakMusicHandles = new Set([
      'facing-mick-keith-ron-charlie',
      'facing-charlie-watts',
      'facing-ron-wood',
      'facing-keith-richard',
      'facing-mick-jagger',
      'de-club-van-27-serie',
      'facing-jim-morrison',
      'facing-janis-joplin',
      'facing-jimi-hendrix',
      'facing-amy-winehouse',
      'the-fab-four-serie',
      'facing-ringo-starr',
      'facing-george',
      'facing-paul',
      'facing-john',
      'paul-mccartney-cadeauboek'
    ]);
    const arrangeBobPolakResults = (products) => [...products].sort((left, right) => {
      const leftIsMusic = bobPolakMusicHandles.has(left.handle);
      const rightIsMusic = bobPolakMusicHandles.has(right.handle);
      if (leftIsMusic !== rightIsMusic) return leftIsMusic ? 1 : -1;
      return byNewest(left, right);
    });
    const looseSpotlightHandles = [
      'schmidt-eenentwintig-poezen',
      'johan-cruijff-elk-nadeel-heb-zen-voordeel',
      'ramses-shaffy-we-zullen-doorgaan',
      'sylvia-witteman-minestrone',
      'kader-abdolah'
    ];
    const looseSpotlight = looseSpotlightHandles.map((handle) => byHandle.get(handle)).filter(Boolean);
    const looseSpotlightSet = new Set(looseSpotlight.map((item) => item.handle));
    const looseBooks = [
      ...looseSpotlight,
      ...sortByVisualLines(catalog.filter((item) => item.kind !== 'series' && !looseSpotlightSet.has(item.handle)).sort(byNewest))
    ];
    const newestHandles = [
      'hans-vervoort-serie',
      'de-amsterdamse-gebouwenserie-de-wolkenkrabber',
      'piet-schreuders-en-de-wolkenkrabber',
      'felix-rottenberg-en-de-wolkenkrabber',
      'hanny-michaelis-en-de-wolkenkrabber',
      'bijenkorf-serie',
      'gk-van-het-reve',
      'gerrit-kouwenaar-en-de-bijenkorf',
      'max-de-jong-en-de-bijenkorf',
      'theodor-holman-en-de-bijenkorf',
      'cockys-soepen-serie'
    ];
    const newestBooks = newestHandles.map((handle) => byHandle.get(handle)).filter(Boolean);
    const bestsellerHandles = [
      'nescio-in-bergen-serie',
      'facing-mick-keith-ron-charlie',
      'm-vasalis-serie',
      'trijntje-fop-serie',
      'the-fab-four-serie',
      'ramses-shaffy-serie',
      'johan-cruijff-serie',
      'jma-biesheuvel-collection',
      'annie-mg-schmidt-collection',
      'collection-c-buddingh',
      'drs-p-serie',
      'vier-grote-schrijvers'
    ];
    const bestsellerRank = new Map(bestsellerHandles.map((handle, index) => [handle, index]));
    let bestsellersPromise;
    const bestsellersBooks = () => {
      if (bestsellersPromise) return bestsellersPromise;
      const routesRoot = window.Shopify?.routes?.root || '/';
      bestsellersPromise = fetch(`${routesRoot}collections/meest-verkocht/products.json?limit=250`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error(`Shopify collectie: ${response.status}`)))
        .then((payload) => (payload.products || []).map((product) => {
          const linked = byHandle.get(canonicalProductHandle(product.handle));
          if (linked) return linked;
          return {
            handle: product.handle,
            title: product.title,
            caption: product.vendor || '',
            url: `/products/${product.handle}`,
            kind: /serie/i.test(`${product.title} ${product.product_type || ''}`) ? 'series' : 'loose',
          };
        }).sort((left, right) =>
          (bestsellerRank.get(left.handle) ?? Number.MAX_SAFE_INTEGER)
          - (bestsellerRank.get(right.handle) ?? Number.MAX_SAFE_INTEGER)));
      return bestsellersPromise;
    };
    const isSeriesProduct = (product) => product?.kind === 'series'
      || byHandle.get(product?.handle)?.kind === 'series'
      || Object.prototype.hasOwnProperty.call(SERIES_GROUPS, product?.handle)
      || /\bserie\b/i.test(String(product?.title || ''));
    const alphabeticalLooseProducts = (products, fallbackToSeries = false) => {
      const unique = [...new Map(products.filter(Boolean).map((product) => [product.handle, product])).values()];
      const loose = unique.filter((product) => !isSeriesProduct(product));
      const selected = loose.length || !fallbackToSeries
        ? loose
        : unique.filter((product) => isSeriesProduct(product));
      return selected.sort((left, right) => collator.compare(left.title || '', right.title || ''));
    };
    const creatorCarouselProducts = (groups, type) => {
      const products = [];
      const added = new Set();
      groups.forEach(([creator, items]) => {
        const selection = type === 'illustrator'
          ? seriesForIllustrator(creator, items)
          : seriesForAuthor(creator, items);
        alphabeticalLooseProducts(selection.products, type === 'illustrator').forEach((product) => {
          if (added.has(product.handle)) return;
          added.add(product.handle);
          products.push({ ...product, _mbCreator: creator });
        });
      });
      return products;
    };
    const arrangeAllResults = () => {
      const inRequestedOrder = DEFAULT_PRODUCT_ORDER.map((handle) => byHandle.get(handle)).filter(Boolean);
      const included = new Set(inRequestedOrder.map((item) => item.handle));
      return [...inRequestedOrder, ...catalog.filter((item) => !included.has(item.handle))];
    };

    const currentHandle = canonicalProductHandle(root.dataset.mbCurrentProduct || '');
    const currentSeriesRelation = (() => {
      if (!currentHandle) return null;
      const currentThemes = byHandle.get(currentHandle)?.themes || [];
      const candidates = SERIES_GROUPS[currentHandle]
        ? [currentHandle]
        : Object.keys(SERIES_GROUPS).filter((handle) => SERIES_GROUPS[handle].includes(currentHandle));
      candidates.sort((left, right) => {
        const overlap = (handle) => (byHandle.get(handle)?.themes || []).filter((theme) => currentThemes.includes(theme)).length;
        return overlap(right) - overlap(left);
      });
      const seriesHandle = candidates[0];
      const seriesProduct = byHandle.get(seriesHandle);
      if (!seriesHandle || !seriesProduct) return null;
      const members = SERIES_GROUPS[seriesHandle].map((handle) => byHandle.get(handle)).filter(Boolean);
      if (!members.length) return null;
      return { seriesHandle, seriesProduct, members, currentIsSeries: currentHandle === seriesHandle };
    })();

    /* Dezelfde gelegenheidsindeling als de cadeaukiezer. Een product kan bij
       meerdere gelegenheden passen; kandidaten met de meeste overlap komen eerst. */
    const relatedOccasionGroups = [
      [38, 68],
      [7, 41, 51, 68, 152],
      [41, 43, 51, 52, 53, 54, 58, 73, 75, 98, 104, 105, 106, 107, 108, 113, 121, 143, 144, 145, 146, 147, 148, 149, 152, 162],
      [7, 9, 27, 35, 41, 45, 46, 47, 48, 51, 57, 58, 68, 73, 75, 89, 98, 102, 104, 105, 106, 107, 108, 109, 114, 116, 117, 118, 136, 148, 149, 152, 153, 162],
      [7, 10, 35, 38, 41, 48, 51, 53, 58, 68, 73, 75, 89, 98, 115, 121, 143, 148, 152],
      [14, 34, 41, 44, 55, 64, 76, 77, 78, 79, 80, 82, 85, 86, 90, 99, 100, 101, 102, 103, 114, 116, 117, 118, 124, 125, 126, 127, 128, 129, 132, 135, 137, 151, 153, 160, 161, 188],
      [8, 14, 34, 35, 41, 46, 56, 70, 71, 99, 101, 102, 109, 114, 116, 117],
      [8, 13, 14, 23, 26, 27, 35, 37, 41, 46, 59, 70, 71, 99, 101, 102, 109, 114, 116, 117],
      [8, 12, 23, 26, 27, 28, 33, 45, 66, 67, 91, 92, 93, 94, 95, 159, 162],
      [2, 10, 14, 30, 33, 40, 41, 44, 52, 56, 59, 69, 78, 161, 173, 183],
      [8, 12, 26, 33, 45, 48, 51, 52, 57, 58, 66, 67, 91, 92, 93, 94, 95, 150, 162],
      [5, 16, 19, 33, 34, 37, 43, 44, 58, 61, 62, 63, 64, 73, 76, 77, 78, 79, 80, 88, 96, 97, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 132, 143, 144, 145, 146, 147, 148, 149, 154, 155, 156, 157, 158, 163, 164, 165, 166, 167, 188],
      [3, 18, 19, 24, 29, 35, 45, 48, 50, 136, 150],
      [3, 19, 24, 50, 136, 150],
      [14, 22, 32, 34, 41, 49, 64, 80, 85, 90, 95, 97, 103, 118, 123, 129, 135, 137, 147, 150, 151, 153, 158, 159, 160, 161, 167, 168, 188],
      [19, 33, 34, 36, 41, 45, 67, 114, 116, 117, 118, 150],
      [14, 33, 34, 41, 44, 50, 52, 79, 82, 99, 101, 114, 116, 117, 118, 136, 150],
      [2, 12, 14, 22, 24, 28, 32, 34, 37, 44, 49, 64, 65, 67, 69, 74, 80, 85, 90, 95, 97, 103, 118, 123, 129, 131, 132, 133, 134, 135, 137, 147, 150, 151, 153, 158, 159, 160, 161, 162, 167, 168, 173, 183, 188],
      [22, 28, 32, 42, 49, 54, 60, 64, 65, 67, 69, 74, 80, 85, 90, 95, 97, 103, 108, 118, 123, 129, 131, 132, 133, 134, 135, 137, 147, 149, 150, 151, 153, 158, 159, 160, 161, 162, 167, 168, 173, 183, 188],
      [2, 5, 8, 12, 13, 14, 19, 20, 22, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 40, 41, 44, 45, 46, 47, 48, 49, 50, 55, 56, 59, 60, 64, 65, 66, 67, 69, 70, 71, 72, 74, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 95, 96, 97, 99, 100, 101, 102, 103, 109, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 143, 144, 145, 146, 147, 150, 151, 153, 154, 155, 156, 157, 158, 159, 160, 161, 163, 164, 165, 166, 167, 168, 173, 183, 188]
    ].map((numbers) => new Set(numbers));

    const sameCategoryItems = (reference, excluded = new Set()) => {
      const themes = new Set(reference?.themes || []);
      return looseBooks
        .filter((item) => !excluded.has(item.handle) && (item.themes || []).some((theme) => themes.has(theme)))
        .sort((left, right) => {
          const overlap = (item) => (item.themes || []).filter((theme) => themes.has(theme)).length;
          return overlap(right) - overlap(left) || Number(right.number || 0) - Number(left.number || 0);
        });
    };

    const sameOccasionItems = (reference, excluded = new Set()) => {
      const referenceNumber = Number(reference?.number || 0);
      const score = (item) => relatedOccasionGroups.filter((group) =>
        group.has(referenceNumber) && group.has(Number(item.number || 0))).length;
      return looseBooks
        .filter((item) => !excluded.has(item.handle) && score(item) > 0)
        .sort((left, right) => score(right) - score(left) || Number(right.number || 0) - Number(left.number || 0));
    };

    const fallbackItems = (reference, count, excluded = new Set()) => {
      const category = sameCategoryItems(reference, excluded);
      if (category.length >= count) return category.slice(0, count);
      const selected = [...category];
      const used = new Set([...excluded, ...selected.map((item) => item.handle)]);
      sameOccasionItems(reference, used).forEach((item) => {
        if (selected.length < count) selected.push(item);
      });
      return selected.slice(0, count);
    };

    const relatedToCurrentProduct = (count) => {
      const current = byHandle.get(currentHandle);
      if (!current) return [];
      return fallbackItems(current, count, new Set([currentHandle]));
    };

    const availableSeparately = (item) => fetch(`${item.url || `/products/${item.handle}`}.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => product ? product.available !== false : true)
      .catch(() => true);

    const counts = {
      themes: (data.categories || []).length,
      /* Houd deze twee publiekscijfers gelijk aan de gecontroleerde statistieken
         op de titellijst. Groepssleutels zijn geen unieke personen en geven
         daardoor een hoger technisch aantal. */
      authors: (() => { try { const names = Object.keys(JSON.parse(document.querySelector('[data-mb-fonds-authors]')?.textContent || '{}')).filter((name) => !['Contactadvertenties', 'Diverse auteurs'].includes(name)); return names.length || 89; } catch (_error) { return 89; } })(),
      illustrators: (() => { try { const names = Object.keys(JSON.parse(document.querySelector('[data-mb-discovery-groups]')?.textContent || '{}').illustrators || {}).filter((name) => name !== 'Contactadvertenties'); return names.length || 51; } catch (_error) { return 51; } })(),
      series: series.length,
      newest: newestBooks.length,
      loose: looseBooks.length
    };
    const countLabels = {
      themes: String(counts.themes),
      authors: String(counts.authors),
      illustrators: String(counts.illustrators),
      designers: String(designerGroups.length),
      series: String(counts.series),
      newest: String(counts.newest),
      loose: String(counts.loose)
    };
    Object.entries(countLabels).forEach(([name, label]) => {
      const target = root.querySelector(`[data-mb-count="${name}"]`);
      if (target) target.textContent = label;
    });

    const showChoices = (items, navigation = null, type = '') => {
      body.classList.remove('has-choice-result');
      choices.replaceChildren(...(navigation ? [navigation] : []), ...items);
      body.dataset.choiceType = type;
      choices.hidden = false;
      choices.removeAttribute('aria-hidden');
      choices.style.removeProperty('display');
      listFooter.hidden = false;
      productsHost.replaceChildren();
      productsHost.hidden = true;
      body.hidden = false;
      searchResults.hidden = true;
    };

    const showDefaultAllMatchBoox = () => {
      tabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
      choices.replaceChildren();
      choices.hidden = true;
      choices.setAttribute('aria-hidden', 'true');
      choices.style.setProperty('display', 'none', 'important');
      listFooter.hidden = true;
      body.removeAttribute('data-choice-type');
      body.hidden = false;
      searchResults.hidden = true;
      renderProducts(productsHost, arrangeAllResults(), 'Alle MatchBoox', '/collections/alle-matchboox');
    };

    const showDefaultSeriesContext = async () => {
      if (!currentSeriesRelation) {
        if (currentHandle) {
          tabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
          choices.replaceChildren();
          choices.hidden = true;
          body.removeAttribute('data-choice-type');
          body.hidden = false;
          searchResults.hidden = true;
          renderProducts(productsHost, relatedToCurrentProduct(5), 'Past goed bij deze MatchBoox');
          return;
        }
        showDefaultAllMatchBoox();
        return;
      }
      tabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
      choices.replaceChildren();
      choices.hidden = true;
      body.removeAttribute('data-choice-type');
      body.hidden = false;
      searchResults.hidden = true;

      const relation = currentSeriesRelation;
      let items;
      if (!relation.currentIsSeries) {
        const current = byHandle.get(currentHandle);
        const otherMembers = relation.members.filter((item) => item.handle !== currentHandle);
        /* Op een losse boekjespagina staat eerst de complete serie, daarna de
           drie andere delen. Het huidige boekje volgt pas als vijfde item,
           zodat het niet opnieuw in de eerste zichtbare carrouselpagina staat. */
        items = [relation.seriesProduct, ...otherMembers, current].filter(Boolean).slice(0, 5);
      } else {
        const availability = await Promise.all(relation.members.map(availableSeparately));
        const availableMembers = relation.members.filter((_, index) => availability[index]).slice(0, 4);
        const excluded = new Set([relation.seriesHandle, ...relation.members.map((item) => item.handle)]);
        const additions = fallbackItems(relation.seriesProduct, 4 - availableMembers.length, excluded);
        items = [...availableMembers, ...additions, relation.seriesProduct];
      }
      renderProducts(
        productsHost,
        items.slice(0, 5),
        relation.currentIsSeries ? 'De boekjes in deze serie' : 'Meer uit deze serie',
        relation.seriesProduct.url
      );
    };

    const openTab = (name) => {
      const selected = tabs.find((tab) => tab.dataset.mbDiscoveryTab === name);
      const isAlreadyOpen = selected?.getAttribute('aria-expanded') === 'true';
      tabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
      if (!selected && !['all', 'collection'].includes(name)) return;
      /* Houd het volgende homepageblok onzichtbaar zodra de bezoeker gericht
         door collectie, thema's, auteurs of illustratoren bladert. De ruimte
         blijft gereserveerd, zodat de pagina niet verspringt. */
      const homeSection = root.closest('.section-matchboox-home');
      homeSection?.classList.remove('mb40--chooser-overview');
      homeSection?.classList.toggle(
        'mb40--chooser-focus',
        ['all', 'collection', 'themes', 'authors', 'illustrators', 'designers'].includes(name)
      );
      /* Alleen sluiten wanneer de keuzelijst zelf nog zichtbaar is. Na een
         productresultaat opent een klik op dezelfde categorie de lijst opnieuw. */
      if (isAlreadyOpen && !choices.hidden) {
        Promise.resolve(showDefaultSeriesContext()).then(() => {
          requestAnimationFrame(() => requestAnimationFrame(() => scrollBelowHeader(productsHost)));
        });
        return;
      }
      selected?.setAttribute('aria-expanded', 'true');
      if (name === 'themes') {
        /* Bewaar de afgesproken fondsvolgorde uit matchboox-carousel-data.liquid. */
        showChoices((data.categories || []).map((category) => {
          const items = (category.items || []).map((item) => byHandle.get(item.handle)).filter(Boolean);
          /* Een thema toont exact dezelfde, beheerde productlijst als de
             bijbehorende themapagina. Voeg hier nooit automatisch de hele
             bovenliggende serie van een los boekje aan toe. */
          return choiceButton(category.name, () => {
            renderProducts(productsHost, items, category.name, category.url, items.length);
          }, 'theme', category.handle);
        }), null, 'themes');
      } else if (name === 'collection') {
        const newestChoice = () => choiceButton('Nieuw verschenen', () => {
          renderProducts(productsHost, newestBooks, 'Nieuw verschenen', '/collections/nieuw-verschenen');
        }, 'collection', 'newest');
        const bestsellersChoice = () => choiceButton('Meest verkocht', () => {
          bestsellersBooks()
            .then((items) => {
              renderProducts(productsHost, items, 'Meest verkocht', '/collections/meest-verkocht');
              requestAnimationFrame(() => requestAnimationFrame(() => scrollBelowHeader(productsHost)));
            })
            .catch(() => renderProducts(productsHost, [], 'Meest verkocht', '/collections/meest-verkocht'));
        }, 'collection', 'bestsellers');
        const fundListChoice = () => choiceButton('Fondslijst', () => {
          window.location.assign('/pages/fondslijst');
        }, 'collection', 'fondslijst');
        const seriesChoice = () => choiceButton('Alle series', () => {
          renderProducts(productsHost, series, 'Alle series', '/collections/series');
        }, 'collection', 'series');
        const looseChoice = () => choiceButton('Alle losse boekjes', () => {
          renderProducts(productsHost, looseBooks, 'Alle losse boekjes', '/collections/losse-boekjes');
        }, 'collection', 'loose');
        const allChoice = () => choiceButton('Alle MatchBoox', () => {
          const allProducts = arrangeAllResults();
          renderProducts(productsHost, allProducts, 'Alle MatchBoox', '/collections/alle-matchboox');
        }, 'collection', 'all');

        if (window.matchMedia('(min-width: 990px)').matches) {
          showChoices([
            newestChoice(),
            bestsellersChoice(),
            choiceButton('Alle auteurs', async () => {
              const products = await mbSortNewest(creatorCarouselProducts(authorGroups, 'author'));
              renderProducts(productsHost, products, 'Alle auteurs', '/pages/auteurs', products.length);
            }, 'collection', 'alle-auteurs'),
            choiceButton('Alle illustratoren', async () => {
              const products = await mbSortNewest(creatorCarouselProducts(illustratorGroups, 'illustrator'));
              renderProducts(productsHost, products, 'Alle illustratoren', '/pages/illustratoren', products.length);
            }, 'collection', 'alle-illustratoren'),
            seriesChoice(),
            looseChoice(),
            allChoice(),
            fundListChoice()
          ], null, 'collection');
        } else {
          showChoices([
            newestChoice(),
            bestsellersChoice(),
            fundListChoice(),
            seriesChoice(),
            looseChoice(),
            allChoice()
          ], null, 'collection');
        }
      } else if (name === 'authors') {
        const authorButtons = authorGroups.map(([author, items]) => choiceButton(author, async () => {
          const selection = seriesForAuthor(author, items);
          /* De fondslijst is hier leidend. Toon daarom iedere expliciet aan de
             auteur gekoppelde uitgave, inclusief serie-uitgaven. De eerdere
             selectie op alleen losse boekjes verborg onder meer een groot deel
             van het fonds van Bob Polak. */
          const unique = [...new Map(selection.products
            .filter(Boolean)
            .map((product) => [product.handle, product])).values()];
          const arranged = await mbSortNewest(unique);
          renderProducts(productsHost, arranged, author, '', arranged.length);
        }, 'author'));
        const allAuthorsButton = choiceButton('Alle auteurs', async () => {
          const products = await mbSortNewest(creatorCarouselProducts(authorGroups, 'author'));
          renderProducts(productsHost, products, 'Alle auteurs', '/pages/auteurs', products.length);
        }, 'author');
        showChoices([allAuthorsButton, ...authorButtons], null, 'authors');
      } else if (name === 'illustrators') {
        const illustratorButtons = illustratorGroups.map(([displayName, items]) => choiceButton(displayName, async () => {
          const selection = seriesForIllustrator(displayName, items);
          /* Ook voor illustratoren blijft de volledige koppeling uit de
             fondslijst intact; serie-uitgaven mogen niet verdwijnen zodra er
             daarnaast losse boekjes bestaan. */
          const arranged = [...new Map(selection.products
            .filter(Boolean)
            .map((product) => [product.handle, product])).values()]
;
          const newestFirst = await mbSortNewest(arranged);
          renderProducts(productsHost, newestFirst, displayName, '', newestFirst.length);
        }, 'illustrator'));
        const allIllustratorsButton = choiceButton('Alle illustratoren', async () => {
          const products = await mbSortNewest(creatorCarouselProducts(illustratorGroups, 'illustrator'));
          renderProducts(productsHost, products, 'Alle illustratoren', '/pages/illustratoren', products.length);
        }, 'illustrator');
        showChoices([allIllustratorsButton, ...illustratorButtons], null, 'illustrators');
      } else if (name === 'designers') {
        const designerButtons = designerGroups.map(([displayName, items]) => choiceButton(displayName, async () => {
          const newestFirst = await mbSortNewest(items);
          renderProducts(productsHost, newestFirst, displayName, '', newestFirst.length);
        }, 'illustrator'));
        const allDesignersButton = choiceButton('Alle vormgevers', async () => {
          const products = await mbSortNewest(designerGroups.flatMap(([, items]) => items));
          renderProducts(productsHost, products, 'Alle vormgevers', '/pages/vormgevers', products.length);
        }, 'illustrator');
        showChoices([allDesignersButton, ...designerButtons], null, 'illustrators');
      } else if (name === 'series') {
        choices.replaceChildren();
        choices.hidden = true;
        body.removeAttribute('data-choice-type');
        body.hidden = false;
        searchResults.hidden = true;
        renderProducts(productsHost, series, 'Series', '/collections/series');
      } else if (name === 'newest') {
        choices.replaceChildren();
        choices.hidden = true;
        body.removeAttribute('data-choice-type');
        body.hidden = false;
        searchResults.hidden = true;
        renderProducts(productsHost, newestBooks, 'Nieuw verschenen', '/collections/nieuw-verschenen');
      } else if (name === 'loose') {
        choices.replaceChildren();
        choices.hidden = true;
        body.removeAttribute('data-choice-type');
        body.hidden = false;
        searchResults.hidden = true;
        renderProducts(productsHost, looseBooks, 'Losse boekjes', '/collections/losse-boekjes');
      } else {
        choices.replaceChildren();
        choices.hidden = true;
        body.removeAttribute('data-choice-type');
        body.hidden = false;
        searchResults.hidden = true;
        renderProducts(productsHost, arrangeAllResults(), 'Alle MatchBoox', '/collections/alle-matchboox');
      }
      const desktopCollection = name === 'all' && window.matchMedia('(min-width: 990px)').matches;
      const scrollTarget = desktopCollection
        ? root
        : ['themes', 'authors', 'illustrators', 'designers', 'collection'].includes(name) ? choices : productsHost;
      requestAnimationFrame(() => requestAnimationFrame(() => scrollBelowHeader(scrollTarget)));
    };

    /* De brede V135-header kan hiermee rechtstreeks de juiste lijst openen.
       Daardoor hoeft een bezoeker niet eerst langs het volledige keuzeblok. */
    root._mbOpenTab = openTab;
    tabs.forEach((tab) => tab.addEventListener('click', () => openTab(tab.dataset.mbDiscoveryTab)));
    showDefaultSeriesContext();

    const searchForm = root.querySelector('[data-mb-discovery-search-form]');
    const searchInput = root.querySelector('[data-mb-discovery-search]');
    let searchToken = 0;
    const makerEditionsFor = async (rawQuery, token) => {
      const slug = normalized(rawQuery).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      if (slug.length < 4) return [];
      const root = window.Shopify?.routes?.root || '/';
      const pages = await Promise.all([1, 2, 3].map((page) => fetch(`${root}search?type=product&page=${page}&q=${encodeURIComponent(rawQuery)}`, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : '')).catch(() => '')));
      if (token !== searchToken) return null;
      const handles = [];
      pages.join(' ').replace(/\/products\/([a-z0-9-]+)/g, (_match, handle) => {
        if ((handle === slug || handle.startsWith(`${slug}-`)) && !handles.includes(handle)) handles.push(handle);
        return '';
      });
      return handles.map((handle) => ({ handle, url: `/products/${handle}`, title: '', caption: rawQuery.replace(/\s+/g, ' ').trim(), kind: /-serie(s)?(-|$)/.test(handle) ? 'series' : 'loose', themes: [], _mbIllustratorVersion: true, _mbSkipVersionFilter: true }));
    };
    const search = async () => {
      const rawQuery = searchInput.value.trim();
      const query = normalized(rawQuery);
      if (query.length < 2) { searchResults.hidden = true; return; }
      const token = ++searchToken;
      tabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
      body.hidden = true;
      const matchingIllustrators = illustratorGroups.filter(([name]) => normalized(name).includes(query));
      const source = matchingIllustrators.length
        ? matchingIllustrators.flatMap(([, items]) => items)
        : catalog;
      let results = [...new Map(source
        .filter((item) => matchingIllustrators.length || normalized([item.title, item.caption, item.handle, ...(item.themes || [])].join(' ')).includes(query))
        .map((item) => [item.handle, item])).values()];
      let editions = [];
      try { editions = await makerEditionsFor(rawQuery, token); } catch (_error) { editions = []; }
      if (editions === null || token !== searchToken) return;
      if (editions.length) {
        const known = new Set(results.map((item) => item.handle));
        const makerName = matchingIllustrators[0]?.[0] || rawQuery.replace(/\s+/g, ' ').trim();
        results = [...results, ...editions.filter((item) => !known.has(item.handle)).map((item) => ({ ...item, caption: makerName, _mbCreator: makerName }))];
      }
      const creatorResults = editions.length > 0 || matchingIllustrators.length > 0;
      if (creatorResults) {
        results = await mbDropAuthorDuplicates(results);
        if (token !== searchToken) return;
        renderProducts(searchResults, results, results.length ? `Zoekresultaten voor “${rawQuery}”` : 'Geen zoekresultaten', '', results.length);
      } else {
        renderSeriesResults(searchResults, results, results.length ? `Zoekresultaten voor “${rawQuery}”` : 'Geen zoekresultaten', '', true);
      }
      searchResults.hidden = false;
    };
    let timer;
    searchInput.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(search, 180); });
    searchForm.addEventListener('submit', (event) => {
      if (searchInput.value.trim().length >= 2) { event.preventDefault(); search(); }
    });
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-mb-discovery]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
